
<template>
    <v-data-table locale="de-DE" :headers="tableHeaders" :items="tableItems" dense hide-default-footer :items-per-page="1000" style="height: 150px; overflow-y: auto">

        <template v-slot:item="props">
            <tr>
            <td style="height: 25px" class="text-left">{{props.item.name}}</td>
            <td style="height: 25px" class="text-right"><select v-model="props.item.StartKnoten" @change="$store.dispatch('resetAndRedraw')"><option v-for="cKnoten in knoten" v-bind:value="cKnoten" :key="cKnoten.name">{{ cKnoten.name }}</option></select></td>            
            <td style="height: 25px" class="text-right"><select v-model="props.item.EndKnoten" @change="$store.dispatch('resetAndRedraw')"><option v-for="cKnoten in knoten" v-bind:value="cKnoten" :key="cKnoten.name">{{ cKnoten.name }}</option></select></td>
            <td style="height: 25px" class="text-right"><select v-model="props.item.Querschnitt" @change="$store.dispatch('resetAndRedraw')"><option v-for="cQuerschnitt in querschnitte" v-bind:value="cQuerschnitt" :key="cQuerschnitt.name">{{ cQuerschnitt.name }}</option></select></td>
            
            <!--ACHTUNG BEIM ÄNDERN DER KNOTEN IN DER TABELLE WERDEN DIE VERKNÜPRUNGEN ZU DEN KNOTEN USW. NICHT ANGEPASST!!!! -->
            
            <td style="height: 25px" class="text-center"><input type="checkbox" v-model="props.item.isFachwerkstab" @change="$store.dispatch('resetAndRedraw')"></td>
            <td></td>
            <td></td>    
            <td style="height: 25px" class="text-right"><input style="text-align:right; width: 60px;" type="number" max="100"  min="1" step="1" v-model.lazy="props.item.Stabteilungen" @change="$store.dispatch('resetAndRedraw')"></td>        
            <td><v-icon color="red" small @click="deleteItem(props.item)">clear</v-icon></td>
            </tr>
        </template>  

        <template v-slot:body.prepend>
            <tr style="background: #C8E6C9">
                <td style="height: 25px" class="text-left">neuer Stab</td>
                <td style="height: 25px" class="text-right"><select style="background: #A5D6A7;" v-model="nStab.Knoten[0]"><option :value="undefined" disabled key="null">...Knoten</option><option v-for="cKnoten in knoten" v-bind:value="cKnoten" :key="cKnoten.name">{{ cKnoten.name }}</option></select></td>
                <td style="height: 25px" class="text-right"><select style="background: #A5D6A7;" v-model="nStab.Knoten[1]"><option :value="undefined" disabled key="null">...Knoten</option><option v-for="cKnoten in knoten" v-bind:value="cKnoten" :key="cKnoten.name">{{ cKnoten.name }}</option></select></td>
                <td style="height: 25px" class="text-right"><select style="background: #A5D6A7;" v-model="nStab.Querschnitt"><option :value="null" disabled key="null">...Querschnitt</option><option v-for="cQuerschnitt in querschnitte" v-bind:value="cQuerschnitt" :key="cQuerschnitt.name">{{ cQuerschnitt.name }}</option></select></td>           
                <td style="height: 25px" class="text-center"><input style="background: #A5D6A7;" type="checkbox" v-model="nStab.isFachwerkstab" @change="$store.dispatch('resetAndRedraw')"></td>
                <td></td>
                <td></td>
                <td style="height: 25px" class="text-right"><input style="text-align:right; width: 60px;" type="number" max="100"  min="1" step="1" v-model.lazy="nStab.Stabteilungen"></td>
                <td><v-btn small icon @click="apply()"><v-icon color="green" small>add_box</v-icon></v-btn></td>
            </tr>
        </template>                  
    </v-data-table>



</template>

<script>
/* eslint-disable */
import Stab from '../../js/Stab'

export default {
    data(){
        return{
            nStab: new Stab,
            // initStatus: this.$store.initStatus,
            tableHeaders: [
                    { text: 'Name', align: 'left', value: 'name'},
                    { text: 'Startknoten', align: 'right', sortable: false, value: 'StartKnoten.name'},
                    { text: 'Endknoten', align: 'right', sortable: false, value: 'EndKnoten.name'},                    
                    { text: 'Querschnitt', align: 'right', sortable: false, value: 'Querschnitt.name'},
                    { text: 'Fachwerkstab', align: 'center', sortable: false, value: 'Fachwerkstab'},
                    { text: 'StartGelenk', align: 'right', sortable: false, value: 'StartGelenk.name'},
                    { text: 'EndGelenk', align: 'right', sortable: false, value: 'EndGelenk.name'},   
                    { text: 'Stabteilungen', align: 'right', sortable: false, value: 'Stabteilungen'},          
                    { value: 'Actions', width: '30px' }
                ],
        }
    },
    computed: {
        querschnitte() { return this.$store.state.StatikSystem.Querschnittliste},
        knoten() { return this.$store.state.StatikSystem.Knotenliste},
        tableItems() { return this.$store.state.StatikSystem.Stabliste},
    },
    methods: {
        checkKnotenChange(position){
            if(this.stab.StartKnoten == this.stab.EndKnoten){
                if(position == 0) {
                    this.stab.EndKnoten = undefined
                    this.$refs.Select2.selectedItems = []
                } else {
                    this.stab.StartKnoten = undefined
                    this.$refs.Select1.selectedItems = []
                } 
            }
        },

        async pickKnoten(KnotenPos){
            if(KnotenPos){
            this.viewMenu = false
            this.$store.state.Selection.Knoten = []
            this.$store.commit('drawKnotenSelection')
            await waitUserInput(this.$store.state.Selection.Knoten)
            this.stab[KnotenPos] = this.$store.state.Selection.Knoten[0]
            console.log('Knoten wurde gewählt', this.$store.state.Selection.Knoten[0])
            this.viewMenu = true
            }
        },

        apply(){
            if (this.nStab.Knoten[0] == undefined || this.nStab.Knoten[1] == undefined || this.nStab.Querschnitt == null) return
            this.$store.state.newStab = true
            this.$store.dispatch('StabDialogApply', this.nStab)
            this.nStab = new Stab
        },
        deleteItem(payload){
            this.$store.commit('StabDialogDelete',payload)
        }

    }
}
</script>

<style scoped>
    select {
        padding-left: 5px; 
        padding-right: 5px;
        cursor: pointer;
        border-style: solid;
    }
    input {
        cursor: pointer;
        border-style: solid;
        border-width: thin;
    }
    .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 25px;
    }   
</style>